import { useGlobalSearchParams } from "expo-router";
import { useEffect } from "react";

import { LoadingSpinner, View } from "@/components";
import BreadcrumbRedirect from "@/components/BreadcrumbRedirect";
import { useEntryAction } from "@/hooks/useEntryAction";
import { useRequireAuth } from "@/hooks/useRequireAuth";
import { useAuthStore } from "@/store";
import { parseEntryParams } from "@/utils/entryParams";

export default function EntryPage() {
  const searchParams = useGlobalSearchParams<{
    action: string;
    msg: string;
    agent: string;
    useCase: string;
    condition: string;
    token: string;
    utm_term: string;
  }>();
  const isAuthInitialized = useAuthStore((s) => s.isAuthInitialized);
  const { execute } = useEntryAction();

  const result = parseEntryParams(searchParams);

  // An SMS handoff only seeds into a conversation owned by the same account as the SMS thread.
  const requiresSignIn =
    result.params?.action === "message" && !!result.params.sourceConversationId;
  const { isAuthenticated } = useRequireAuth({ enabled: requiresSignIn });

  useEffect(() => {
    if (result.error || !result.params || !isAuthInitialized) return;
    if (requiresSignIn && !isAuthenticated) return;

    execute(result.params, result.utmTerm);
  }, [isAuthInitialized, requiresSignIn, isAuthenticated, result, execute]);

  if (result.error) {
    return (
      <BreadcrumbRedirect
        href="/"
        reason={result.error}
        context={searchParams as Record<string, unknown>}
      />
    );
  }

  return (
    <View
      flex={1}
      alignItems="center"
      justifyContent="center"
      backgroundColor="$backgroundFill"
    >
      <LoadingSpinner size={72} />
    </View>
  );
}
